import React, { useState } from 'react';
import classes from './Notifications.module.scss';
import { INotification } from '../../models/INotifications';
import NotificationCard from '../../components/NotificationCard/NotificationCard';
import { Carousel, CarouselItem, Dropdown } from 'react-bootstrap';
import arrowLeft from '../../assets/png/arrowLeft.png';
import arrowRight from '../../assets/png/arrowRight.png';
import LogoutSvg from '../../assets/svg/LogoutSvg';
import LogoutModal from '../../components/common/LogoutModal/LogoutModal';
import useLogout from '../../utils/hooks/useLogout';
import DateCarousal from '../../components/DateCarousal/DateCarousal';
import moment from 'moment';
import Loader from '../../components/common/Loader/Loader';

const DATA = [
  'Tuesday, April 2',
  'Wednesday, April 3',
  'Thursday, April 4',
  'Friday, April 5',
];

const DATE_FORMAT = 'dddd, MMMM D';

const Notifications = ({
  notifications,
  isLoading,
  date,
  setDate,
}: {
  notifications: INotification[];
  isLoading: boolean;
  date: string;
  setDate: (date: any) => void;
}) => {
  const { logout } = useLogout();
  const [logoutModalOpen, setLogoutModalOpen] = useState<boolean>(false);

  const getClassName = (type: string) => {
    let cls = '';
    switch (type) {
      case 'product_presentation':
        cls = classes.peekaboo_card;
        break;
      case 'one_to_one_sale':
        cls = classes.onetoone_card;
        break;
      case 'total_sale':
        cls = classes.sale_card;
        break;
      case 'active_in_app':
        cls = classes.activeapp_card;
        break;
      default:
        cls = classes.activeapp_card;
    }
    return cls;
  };

  const handleLogout = () => {
    setLogoutModalOpen(true);
  };

  const handleNextClick = () => {
    setDate(moment(date).add(1, 'days'));
  };
  const handleBackClick = () => {
    setDate(moment(date).subtract(1, 'days'));
  };

  return (
    <div className={classes.container}>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <button className={classes.logout_btn} onClick={handleLogout}>
            Logout
            <LogoutSvg />
          </button>
          <div className={classes.main_heading}>Notifications</div>
          <div className={classes.date_carousal_container}>
            <DateCarousal
              date={moment(date).format(DATE_FORMAT)}
              onClickBack={handleBackClick}
              onClickNext={handleNextClick}
              dateClassName={classes.date_class}
            />
          </div>
          <div className={classes.notifications_container}>
            {notifications?.map((notification: any) => {
              return (
                <NotificationCard
                  notification={notification}
                  circleClassName={getClassName(notification?.goal_type)}
                />
              );
            })}
          </div>
          {logoutModalOpen && (
            <LogoutModal
              isOpen={logoutModalOpen}
              setIsOpen={setLogoutModalOpen}
              handleLogout={logout}
            />
          )}
        </>
      )}
    </div>
  );
};

export default Notifications;
